export default class DashboardController {
  constructor(Auth, Dashboard, Messages) {
    'ngInject';

    this.currentUser = Auth.currentUser;
    this.Dashboard = Dashboard;
    this.Messages = Messages;
    this.notificationTypes = [
      { value: 'global', label: 'Global', selected: true },
      { value: 'personal', label: 'You'},
    ];
    this.notifications = [];
  }

  $onInit() {
    this.loadStatistics();
    this.loadTasks();
  }

  loadStatistics() {
    this.Dashboard.getStatistics()
      .then((statistics) => {
        this.statistics = statistics;
        this.satisfaction = statistics.task_rating_data.satisfaction;
        this.softwareBreakdown = statistics.task_technology_breakdown_data.technology_breakdown['Software'];
      });
  }

  loadTasks() {
    this.Dashboard.getTasks()
      .then((response) => {
        this.tasks = response.tasks;
      });
  }

  loadMoreNotifications() {
    this.page += 1;
    this.loadNotifications({filter: this.selectedNotificationFilter, page: this.page});
  }

  loadNotifications(params = {}) {
    const oldNotifications = this.notification;
    this.notificationLoading = true;
    this.Dashboard.getNotifications(params)
      .then((response) => {
        this.lastResponse = response.notifications;
        this.notifications.push(...response.notifications);
        this.notificationLoading = false;
      })
      .catch((error) => {
        this.notificationLoading = false;
        this.notifications = oldNotifications;
      });
  }

  onTypeSelect(option) {
    this.selectedNotificationFilter = option.value;
    this.notifications = [];
    this.page = 1;
    this.loadNotifications({filter: this.selectedNotificationFilter, page: this.page});
  }

  onMessageSubmit(message) {
    const newNotification = {
      subject_type: 'Message',
      subject_text: message.body,
      created_at: new Date,
      from_name: `${this.currentUser.first_name} ${this.currentUser.last_name}`,
      from: this.currentUser,
    }
    this.notifications.unshift(newNotification);

    this.Messages.create(message)
      .catch((response) => {
        this.notifications.shift();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/dashboard/dashboard.controller.js